import { createFileRoute } from "@tanstack/react-router";
import { TenantUsageTab } from "../features/tenants/pages/tenant-usage-tab";

export const Route = createFileRoute("/tenants/$tenantId/usage")({
  component: TenantUsageTab,
});
